import { AppThunk } from "../store";
import { setHideGlobalNavbarStart, setHideGlobalNavbarSuccess } from "./alterLayout.global.slice";

export const setHideGlobalNavbar = (hide: boolean, onSuccess?: () => void): AppThunk => (dispatch) => {
    dispatch(setHideGlobalNavbarStart());
    dispatch(setHideGlobalNavbarSuccess(hide));
    if(onSuccess)
        onSuccess();
};